import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import ProductCard from '../../components/ProductCard/ProductCard';
import { FaTimesCircle, FaChevronRight, FaChevronDown } from "react-icons/fa"
import { postProduct, postProductFilter, postStoreCart, AddWishlist, RemoveWishlist } from '../../apiservices/ApiServices';
import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import Loader from '../../components/Loader/Loader';
import { ToastContainer, toast } from 'react-toastify';
import ReactSlider from "react-slider";
import { useCartWishlist } from '../CartWishlistContext';
import useScrollRestoration from '../useScrollRestoration';

const Search = () => {
    const [searchText, setSearchText] = useState('');
    const [recordsTotal, setRecordsTotal] = useState('');
    const [isDefault, setIsDefault] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [isFLoading, setFLoading] = useState(true);
    const [data, setData] = useState([]);
    const [proData, setProData] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [isAllData, setIsAllData] = useState(false);
    const [msg, setMsg] = useState('');
    const [ismsg, setisMsg] = useState(false);
    const [isFilter, setFilter] = useState(false);
    const [filters, setFilters] = useState({ filter_brand: [], filter_models: [], filter_attributes: [] });
    const [selectedFilters, setSelectedFilters] = useState({ brands: new Set(), models: new Set(), attributes: {} });
    const [isInStock, setIsInStock] = useState(false);
    const [wishlistsTot, setWishlistsTot] = useState(1);



    const [priceRange, setPriceRange] = useState([]);

    const [expandedBrandId, setExpandedBrandId] = useState(null);
    const [expandedAttrId, setExpandedAttrId] = useState(null);
    const [isBrand, setIsBrand] = useState(false);
    const { cart, setCart, wishlist, isLogin, setIsLogin, addToCart, toggleWishlist } = useCartWishlist();
    const [selectedSortBy, setSelectedSortBy] = useState(() => (localStorage.getItem("selectedSortBys") || "").trim());

    const [searchParams, setSearchParams] = useSearchParams();
    const urlPage = Math.max(Number(searchParams.get("page")) || 1, 1);
    const query = searchParams.get('q') || '';
    // URL (?page=) is the single source of truth for the current page
    const page = urlPage - 1;
    const [reloadKey, setReloadKey] = useState(0);
    const reqIdRef = useRef(0);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage] = useState(20);

    useScrollRestoration(!isLoading);

    useEffect(() => {
        setIsInStock(false);
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);

    const toggleBrandExpand = (brandId) => {
        setExpandedBrandId(prev => (prev === brandId ? null : brandId));
    };

    const toggleAttrExpand = (attrId) => {
        setIsBrand(false);
        setExpandedAttrId(prev => (prev === attrId ? null : attrId));
    };

    const handlePageChange = (newPage) => {
        const pageNumber = newPage + 1;
        if (pageNumber === urlPage) return;

        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            params.set('q', query);
            params.set('page', pageNumber.toString());
            return params;
        });
    };

    // Go to page 1; if already there, force a refetch. Only one fetch happens (via the effect).
    const refetchFromFirstPage = () => {
        if (urlPage === 1) {
            setReloadKey(k => k + 1);
        } else {
            setSearchParams(prev => {
                const params = new URLSearchParams(prev);
                params.set('q', query);
                params.set('page', '1');
                return params;
            });
        }
    };

    const handleSortChange = (value) => {
        const sortValue = (value || '').trim();
        if (sortValue) {
            localStorage.setItem("selectedSortBys", sortValue);
        } else {
            localStorage.removeItem("selectedSortBys");
        }
        setSelectedSortBy(sortValue);
        refetchFromFirstPage();
    };

    const postProducts = async (postdata) => {
        const reqId = ++reqIdRef.current;
        try {
            const res = await postProduct(postdata);
            if (reqId !== reqIdRef.current) return; // stale response, ignore
            setRecordsTotal('');
            setProData([]);
            setProData([]);
            setData([]);

            const total = res.data.data.recordsTotal;
            setTotalPages(Math.ceil(total / perPage));
            setRecordsTotal(total)

            setProData(Array.isArray(res.data.data.records) ? res.data.data.records : []);
            setData(res.data.data);

            setLoading(false);
            setisMsg(false);
            setisMsg(false);
            setFilter(false);

        } catch (error) {
            if (reqId !== reqIdRef.current) return;
            setLoading(false);
            setHasMore(false);
            setRecordsTotal('');
            setProData([]);
            setData([]);
            setFilters([]);
            setFilter(false);
            setisMsg(true);
            setMsg(error.response?.data?.message || 'Error fetching products');
            setData(error.response?.data?.data || []);
        }
    };

    const productsFilter = async (postdata) => {
        setFLoading(true);
        try {
            const res = await postProductFilter(postdata);
            setFilters(res.data.data);
            const priceRanges = localStorage.getItem("priceRanges");

            if (priceRanges) {
                const savedPriceRange = JSON.parse(priceRanges);

                if (Array.isArray(savedPriceRange) && savedPriceRange.length === 2) {
                    setPriceRange(savedPriceRange.map(Number));
                }
            }
            else {
                setPriceRange([
                    res.data.data.min_product_price,
                    res.data.data.max_product_price,
                ]);
            }
            setFLoading(false);
        } catch (error) {
            setFLoading(false);
        }
    };

    const clearFilters = async () => {
        setIsAllData(false);
        setHasMore(true);
        setisMsg(false);
        setFilter(false);

        setSelectedFilters({ brands: new Set(), models: new Set(), attributes: {} });
        setIsInStock(false);
        setSelectedSortBy('');
        setPriceRange([0, filters?.max_product_price]);

        localStorage.removeItem("instockonlys");
        localStorage.removeItem("priceRanges");
        localStorage.removeItem("selectedFilterss");
        localStorage.removeItem("selectedSortBys");

        // reload filter options/price range once, products via effect
        productsFilter({
            search_text: query || '',
            page: 0,
            length: perPage,
        });
        refetchFromFirstPage();
    };

    const applyFilters = async () => {
        setIsAllData(false);
        setHasMore(true);
        setisMsg(false);
        setFilter(false);

        localStorage.setItem("selectedFilterss", JSON.stringify({
            brands: Array.from(selectedFilters.brands),
            models: Array.from(selectedFilters.models),
            attributes: Object.fromEntries(
                Object.entries(selectedFilters.attributes).map(
                    ([attrId, valueSet]) => [
                        attrId,
                        Array.from(valueSet)
                    ]
                )
            )
        })
        );

        if (isInStock) {
            localStorage.setItem("instockonlys", 1);
        } else {
            localStorage.removeItem("instockonlys");
        }

        if (selectedSortBy) {
            localStorage.setItem("selectedSortBys", selectedSortBy);
        } else {
            localStorage.removeItem("selectedSortBys");
        }

        if (priceRange.length === 2) {
            localStorage.setItem("priceRanges", JSON.stringify(priceRange));
        } else {
            localStorage.removeItem("priceRanges");
        }

        // effect reads saved filters from localStorage and fetches once
        refetchFromFirstPage();
    };

    useEffect(() => {
        setSearchText(query);
        setLoading(true);
        setIsAllData(false);
        setHasMore(true);
        setisMsg(false);
        setFilter(false);

        const instockonlys = localStorage.getItem("instockonlys");
        const priceRanges = localStorage.getItem("priceRanges");
        const storedSelectedFilters = localStorage.getItem("selectedFilterss");
        const formData = new FormData();
        formData.append("search_text", query || '');
        formData.append("length", perPage);
        formData.append("page", page);

        if (instockonlys) {
            setIsInStock(true);
            formData.append("instockonly", 1);
        }
        else {
            setIsInStock(false);
        }

        if (selectedSortBy) {
            formData.append("sort_by", selectedSortBy);
        }

        if (priceRanges) {
            const savedPriceRange = JSON.parse(priceRanges);

            if (Array.isArray(savedPriceRange) && savedPriceRange.length === 2) {
                setPriceRange(savedPriceRange.map(Number));
                formData.append("min_amount", Number(savedPriceRange[0]));
                formData.append("max_amount", Number(savedPriceRange[1]));
            }
        }

        if (storedSelectedFilters) {

            const savedFilters = JSON.parse(storedSelectedFilters);

            const attributes = {};

            Object.entries(savedFilters.attributes || {}).forEach(
                ([attrId, values]) => {
                    attributes[attrId] = new Set(
                        values.map(String)
                    );
                }
            );

            setSelectedFilters({
                brands: new Set(
                    (savedFilters.brands || []).map(String)
                ),
                models: new Set(
                    (savedFilters.models || []).map(String)
                ),
                attributes
            });


            Array.from(savedFilters.brands || []).forEach((brandId) => {
                formData.append("brand_id[]", brandId); // Use array notation to send multiple values
            });

            Array.from(savedFilters.models || []).forEach((modelsId) => {
                formData.append("model_id[]", modelsId); // Use array notation to send multiple values
            });

            Object.values(savedFilters.attributes || {}).flatMap(set => Array.from(set))
                .forEach((attrValueId) => {
                    formData.append("attribute_value_id[]", attrValueId);
                });
        }
        else {
            setSelectedFilters({ brands: new Set(), models: new Set(), attributes: {} });
        }




        setIsDefault(false);
        postProducts(formData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, query, reloadKey]);

    // Filter options only depend on the search text, not on page/sort
    useEffect(() => {
        productsFilter({
            search_text: query || '',
            page: 0,
            length: perPage,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    const handleBrandChange = (id) => {
        id = String(id);

        setSelectedFilters((prev) => {
            const updatedBrands = new Set(prev.brands);

            if (updatedBrands.has(id)) {
                updatedBrands.delete(id);
            } else {
                updatedBrands.add(id);
            }

            return {
                ...prev,
                brands: updatedBrands
            };
        });
    };

    const handleModelsChange = (id) => {
        id = String(id);

        setSelectedFilters((prev) => {
            const updatedModels = new Set(prev.models);

            if (updatedModels.has(id)) {
                updatedModels.delete(id);
            } else {
                updatedModels.add(id);
            }

            return {
                ...prev,
                models: updatedModels
            };
        });
    };

    const handleAttributeChange = (attrId, valueId) => {
        attrId = String(attrId);
        valueId = String(valueId);

        setSelectedFilters((prev) => {
            const updatedAttrs = { ...prev.attributes };
            const updatedSet = new Set(updatedAttrs[attrId] || []);

            if (updatedSet.has(valueId)) {
                updatedSet.delete(valueId);
            } else {
                updatedSet.add(valueId);
            }

            updatedAttrs[attrId] = updatedSet;

            return {
                ...prev,
                attributes: updatedAttrs
            };
        });
    };

    return (
        <>
            <Header CartTot={cart.length} WishTot={wishlistsTot} toast={toast} />
            <ToastContainer />


            <div id='FindYourModel'>
                <section id='product'>
                    <div className='product-block'>
                        {isDefault ? null : <>
                            {isLoading ? <Loader /> :
                                <Container>
                                    {ismsg ?
                                        <>
                                            <div className='profilter'>
                                                <Row>
                                                    <Col md={6}>
                                                        <div className='hedtitleFilters'>
                                                            <button type="submit" className="filterio" onClick={() => setFilter(!isFilter)} >
                                                                <svg focusable="false" width="16" height="16" className="icon icon--filters icon--inline" viewBox="0 0 16 16">
                                                                    <path d="M0 4h16M0 12h16" fill="none" stroke="currentColor" strokeWidth=""></path>
                                                                    <circle cx="5" cy="4" r="2" fill="rgb(var(--background))" stroke="currentColor" strokeWidth="2"></circle>
                                                                    <circle cx="11" cy="12" r="2" fill="rgb(var(--background))" stroke="currentColor" strokeWidth="2"></circle>
                                                                </svg>Filter By<svg focusable="false" width="12" height="8" className="icon icon--chevron" viewBox="0 0 12 8">
                                                                    <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2"></path>
                                                                </svg>
                                                            </button>
                                                            <div className="found"><b>{recordsTotal.length == 0 ? 0 : recordsTotal}</b> Products Found</div>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className='rightFilter'>
                                                            <select
                                                                className='sortbyfilter'
                                                                value={selectedSortBy}
                                                                onChange={(e) => handleSortChange(e.target.value)}
                                                            >
                                                                <option value="">Sort By</option>
                                                                {filters?.sort_by?.map((item) => (
                                                                    <option key={item.slug} value={item.slug}>
                                                                        {item.title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className='nodata'>
                                                <h2>{msg}</h2>
                                                <div className='buttonbox'>
                                                    <button className='btn btn-red mr-5' onClick={clearFilters}>Clear Filter</button>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className='profilter'>
                                                <Row>
                                                    <Col md={6}>
                                                        <div className='hedtitleFilters'>
                                                            <button type="submit" className="filterio" onClick={() => setFilter(!isFilter)} >
                                                                <svg focusable="false" width="16" height="16" className="icon icon--filters icon--inline" viewBox="0 0 16 16">
                                                                    <path d="M0 4h16M0 12h16" fill="none" stroke="currentColor" strokeWidth=""></path>
                                                                    <circle cx="5" cy="4" r="2" fill="rgb(var(--background))" stroke="currentColor" strokeWidth="2"></circle>
                                                                    <circle cx="11" cy="12" r="2" fill="rgb(var(--background))" stroke="currentColor" strokeWidth="2"></circle>
                                                                </svg>Filter By<svg focusable="false" width="12" height="8" className="icon icon--chevron" viewBox="0 0 12 8">
                                                                    <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2"></path>
                                                                </svg>
                                                            </button>
                                                            <div className="found"><b>{recordsTotal.length == 0 ? 0 : recordsTotal}</b> Products Found</div>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className='rightFilter'>
                                                            <select
                                                                className='sortbyfilter'
                                                                value={selectedSortBy}
                                                                onChange={(e) => handleSortChange(e.target.value)}
                                                            >
                                                                <option value=" ">Sort By</option>
                                                                {filters?.sort_by?.map((item) => (
                                                                    <option key={item.slug} value={item.slug}>
                                                                        {item.title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div className='product-box'>
                                                <Row>
                                                    {proData.map((item, index) => {
                                                        return (
                                                            <Col md={3} key={`pro_${item.sku_id}_idsss${index}`}>
                                                                <ProductCard
                                                                    PlanName={item?.eligible_plan_name}
                                                                    PlanContent={item?.thumbnail_description}
                                                                    Name={item.name}
                                                                    SkuID={item.sku_id}
                                                                    ImgUrl={item?.media_list[0]?.media_url}
                                                                    Offer={item.discount_per}
                                                                    Price={item.price}
                                                                    OldPrice={item.actual_price}
                                                                    ProductSlug={item.slug}
                                                                    ProductLabel={item?.product_label}
                                                                    Quantitys={item.quantity}
                                                                    Brands={item?.brands?.name}
                                                                    Model={item?.model?.name}
                                                                    Cart={cart}
                                                                    Wishlist={wishlist}
                                                                    ToggleWishlist={toggleWishlist}
                                                                    addToCart={addToCart}
                                                                />
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                                {data.recordsTotal > perPage && (
                                                    <nav className="pager">
                                                        <button
                                                            className="arrow"
                                                            aria-label="Prev"
                                                            onClick={() => handlePageChange(Math.max(page - 1, 0))}
                                                            disabled={page === 0}
                                                        >
                                                            <FaAnglesLeft />
                                                        </button>

                                                        {Array.from({ length: totalPages }, (_, index) => {
                                                            const pageNumber = index + 1;

                                                            return (
                                                                <button
                                                                    key={pageNumber}
                                                                    className={pageNumber === page + 1 ? 'on' : ''}
                                                                    onClick={() => handlePageChange(index)}
                                                                >
                                                                    {pageNumber}
                                                                </button>
                                                            );
                                                        })}

                                                        <button
                                                            className="arrow"
                                                            aria-label="Next"
                                                            onClick={() =>
                                                                handlePageChange(
                                                                    Math.min(page + 1, totalPages - 1)
                                                                )
                                                            }
                                                            disabled={page === totalPages - 1}
                                                        >
                                                            <FaAnglesRight />
                                                        </button>
                                                    </nav>
                                                )}
                                            </div>
                                        </>
                                    }
                                </Container>
                            }

                            {isFLoading ? <Loader /> :
                                <Container>
                                    <div id='filters' className={isFilter ? 'open' : ''}>
                                        <div className='filters-header'>
                                            <h4>Filter</h4>
                                            <button className='btn btn-cricle' onClick={() => setFilter(!isFilter)}><FaTimesCircle /></button>
                                        </div>


                                        <div className='filters-body'>
                                            {isFilter &&
                                                <div className='filter-group'>
                                                    <ul className='filterList'>
                                                        <li>
                                                            <div>
                                                                <input
                                                                    id="isInStockonly"
                                                                    type="checkbox"
                                                                    checked={isInStock}
                                                                    onChange={(e) => setIsInStock(e.target.checked)}
                                                                />
                                                                <span className="chkmark"></span>
                                                                <label htmlFor='isInStockonly'>In stock only</label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    {filters?.min_product_price != filters?.max_product_price && (
                                                        <div className="blk">
                                                            <div className="htitle">Price Range</div>
                                                            <ReactSlider
                                                                className="horizontal-slider"
                                                                thumbClassName="thumb"
                                                                trackClassName="track"
                                                                value={priceRange}
                                                                min={0}
                                                                max={filters?.max_product_price}
                                                                step={50}
                                                                onChange={(value) => setPriceRange(value)}
                                                            />
                                                            <div className="range-vals">
                                                                <span>&#8377;{priceRange[0]}</span>
                                                                <span>&#8377;{priceRange[1]}</span>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <ul className='filterList'>
                                                        <li>
                                                            <button className={isBrand ? 'togglebuttons open' : 'togglebuttons'} onClick={() => setIsBrand(!isBrand)}>
                                                                <p>Brand</p>
                                                                {isBrand ? <FaChevronDown /> : <FaChevronRight />}
                                                            </button>
                                                            {isBrand &&
                                                                <ul className='minischild'>
                                                                    {filters.filter_brand.map((brand) => {
                                                                        const isExpanded = expandedBrandId === brand.id;
                                                                        return (
                                                                            <li key={brand.id}>
                                                                                <div className={isExpanded ? 'accord_hed open' : 'accord_hed'}>
                                                                                    <div>
                                                                                        <input
                                                                                            id={`brand_${brand.id}`}
                                                                                            type="checkbox"
                                                                                            checked={selectedFilters.brands.has(String(brand.id))}
                                                                                            onChange={() => handleBrandChange(brand.id)}
                                                                                        />
                                                                                        <span className="chkmark"></span>
                                                                                        <label htmlFor={`brand_${brand.id}`}>{brand?.name?.toLowerCase()}</label>
                                                                                    </div>
                                                                                    <button onClick={() => toggleBrandExpand(brand.id)}>
                                                                                        {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                                                                                    </button>
                                                                                </div>
                                                                                {isExpanded &&
                                                                                    <ul className='subchild'>
                                                                                        {brand.models.map((model) => (
                                                                                            <li key={model.id}>
                                                                                                <div>
                                                                                                    <input
                                                                                                        id={`model_${model.id}`}
                                                                                                        type="checkbox"
                                                                                                        checked={selectedFilters.models.has(String(model.id))}
                                                                                                        onChange={() => handleModelsChange(model.id)}
                                                                                                    />
                                                                                                    <span className="chkmark"></span>
                                                                                                    <label htmlFor={`model_${model.id}`}>{model?.name?.toLowerCase()}</label>
                                                                                                </div>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                }
                                                                            </li>
                                                                        )
                                                                    })}
                                                                </ul>
                                                            }
                                                        </li>
                                                        {filters?.filter_attributes?.map((attr) => {
                                                            const isExpandeds = expandedAttrId === attr.id;
                                                            return (
                                                                <li key={attr.id}>
                                                                    <button className={isExpandeds ? 'togglebuttons open' : 'togglebuttons'} onClick={() => toggleAttrExpand(attr.id)}>
                                                                        <p>{attr?.name?.toLowerCase()}</p>
                                                                        {isExpandeds ? <FaChevronDown /> : <FaChevronRight />}
                                                                    </button>
                                                                    {isExpandeds &&
                                                                        <ul className='subchild'>
                                                                            {attr.values.map((val) => (
                                                                                <li key={val.id}>
                                                                                    <div>
                                                                                        <input
                                                                                            id={`attr_${val.id}`}
                                                                                            type="checkbox"
                                                                                            checked={
                                                                                                selectedFilters.attributes[String(attr.id)]?.has(String(val.id)) || false
                                                                                            }
                                                                                            onChange={() => handleAttributeChange(attr.id, val.id)}
                                                                                        />
                                                                                        <span className="chkmark"></span>
                                                                                        <label htmlFor={`attr_${val.id}`}>{val?.title?.toLowerCase()}</label>
                                                                                    </div>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    }
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            }
                                        </div>


                                        <div className='filters-footer'>
                                            <button className='btn btn-green' onClick={applyFilters}>Apply Filter</button>
                                            <button className='btn btn-red' onClick={clearFilters}>Clear All</button>
                                        </div>
                                    </div>
                                </Container>
                            }
                        </>
                        }
                    </div>
                </section>

            </div>
            <Footer toast={toast} />
        </>
    )
}

export default Search